import { CKEditor } from '@ckeditor/ckeditor5-react';
import { Form, FormInstance, Input, Typography } from 'antd';
import { FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ClassicEditor, EventInfo } from 'ckeditor5';
import { CK_EDITOR_CONFIG } from '../../../../../components/richInput/ckEditorConfig';

// styles
import 'ckeditor5/ckeditor5.css';
import { Announcement } from '../models/announcement';
import { isRTL } from 'core/services/language';
import FormElement from 'components/formElement/formElement';
import RichInput from 'components/richInput/richInput';

interface AnnouncementFormComponentProps {
	language: 'ar' | 'en';
	form: FormInstance;
}

const AnnouncementFormComponent: FunctionComponent<AnnouncementFormComponentProps> = ({ language, form }) => {
	const { t } = useTranslation();

	const onContentChange = (data: string) => {
		form.setFieldsValue({ [`content_${language}`]: data });
	};

	return (
		<>
			<div>
				<Typography.Text>{t(`ACTIONS.TITLE_IN_${language.toUpperCase()}`)}</Typography.Text>
				<Form.Item name={`title_${language}`} rules={[{ required: true, message: t('COMMON.FIELD_REQUIRED') }]} style={{ maxWidth: 'unset' }}>
					<Input />
				</Form.Item>
			</div>

			<div className="mt-4">
				<Typography.Text>{t(`ACTIONS.EXCERPT_IN_${language.toUpperCase()}`)}</Typography.Text>
				<Form.Item name={`excerpt_${language}`} rules={[{ required: true, message: t('COMMON.FIELD_REQUIRED') }]} style={{ maxWidth: 'unset' }}>
					<Input />
				</Form.Item>
			</div>

			<div className="mt-4">
				<Typography.Text>{t(`ACTIONS.CONTENT_IN_${language.toUpperCase()}`)}</Typography.Text>
				<Form.Item name={`content_${language}`} rules={[{ required: true, message: t('COMMON.FIELD_REQUIRED') }]} style={{ maxWidth: 'unset' }}>
					<RichInput onChange={onContentChange} />
				</Form.Item>
			</div>
		</>
	);
};

export default AnnouncementFormComponent;
